import { isBitramp } from "@/utils/utils";
import React, { useEffect, useRef, useState } from "react";

interface Props {
  title: string;
  subtitle: string;
  actionCallback: (selectedId: number | string) => void;
  buttonText: string;
  placeHolder: string;

  options: { label: string; value: number | string }[] | null;
  resetSignal?: number;
}

const DropDownComponent: React.FC<Props> = ({
  subtitle,
  title,
  placeHolder,
  options,
  actionCallback,
  resetSignal,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSelectedOption("");
    setIsOpen(false);
  }, [resetSignal]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option: {
    label: string;
    value: number | string;
  }) => {
    setSelectedOption(option.label);
    setIsOpen(false);
    if (typeof option.value === "number") {
      actionCallback(Number(option.value)); // Transmite ID-ul selectat
      return;
    }

    actionCallback(option.value); // Transmite ID-ul selectat
  };

  return (
    <div className="dropDownComponent" ref={dropdownRef}>
      <div className="Subtitle dark-blue semi-bold">{title}</div>
      <div className="Text dark-blue medium">{subtitle}</div>
      <div>
        <div
          onClick={toggleDropdown}
          className="dropDownComponent__button Input Text dark-blue "
        >
          {selectedOption ? selectedOption : placeHolder}
          <svg
            width="13"
            height="11"
            viewBox="0 0 13 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={isOpen ? "rotate180" : "reverseRotate180"}
          >
            <path
              id="Polygon 3"
              d="M7.35044 9.6252C6.95955 10.2571 6.04045 10.2571 5.64956 9.6252L0.948823 2.02607C0.536717 1.35987 1.0159 0.5 1.79926 0.5L11.2007 0.500001C11.9841 0.500001 12.4633 1.35987 12.0512 2.02607L7.35044 9.6252Z"
              fill={`${isBitramp() ? "white" : "#222B45"}`}
            />
          </svg>
        </div>

        {isOpen && (
          <div className="dropDownComponent__menu Input Text dark-blue">
            {options &&
              options.map((option, index) => (
                <div
                  key={index}
                  className={` ${
                    isBitramp()
                      ? "hover:!bg-[#262626] dropDownComponent__menu-item"
                      : "dropDownComponent__menu-item"
                  }`}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.label}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DropDownComponent;
